import { render, staticRenderFns } from "./button.vue?vue&type=template&id=b2ce83ea&scoped=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"
import style0 from "./button.vue?vue&type=style&index=0&id=b2ce83ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ce83ea",
  null
  
)

export default component.exports